import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IElearningTopicContentTranslationVm } from '../elearning-topic-content-translation-vm.model';
import { IOperatorElearningTopicContentTranslationIm } from '../operator-elearning-topic-content-translation-im.model';
import { IOperatorElearningTopicContentTranslationUm } from '../operator-elearning-topic-content-translation-um.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningTopicContentTranslationService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningTopicContentTranslation`;
  }
  post(translationIm: IOperatorElearningTopicContentTranslationIm): Observable<IElearningTopicContentTranslationVm> {
    const headers = this.createHeaders();
    return this.http.post<IElearningTopicContentTranslationVm>(this.baseUrl, translationIm, { headers });
  }
  put(translationUm: IOperatorElearningTopicContentTranslationUm): Observable<IElearningTopicContentTranslationVm> {
    const headers = this.createHeaders();
    return this.http.put<IElearningTopicContentTranslationVm>(this.baseUrl, translationUm, { headers });
  }
  delete(id: number): Observable<any> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (id !== undefined && id !== null) {
      params = params.set('id', id.toString());
    }
    return this.http.delete<any>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
